export const makeUrlWithParams = (
  url: string,
  params: Record<string, string>
) => `${url}?${new URLSearchParams(params)}`;
